import { FacilityEntityType } from "./facility-policy-enums";

export type FacilityUuidKey = "officeUuid" | "floorUuid" | "zoneUuid" | "resourceUuid";

export const entityTypeToUuidKey: Record<FacilityEntityType, FacilityUuidKey> = {
  [FacilityEntityType.OFFICE]: "officeUuid",
  [FacilityEntityType.FLOOR]: "floorUuid",
  [FacilityEntityType.ZONE]: "zoneUuid",
  [FacilityEntityType.RESOURCE]: "resourceUuid",
};

export const entityTypeToBookingParam: Record<FacilityEntityType, string> = {
  [FacilityEntityType.OFFICE]: "officeIds",
  [FacilityEntityType.FLOOR]: "floorIds",
  [FacilityEntityType.ZONE]: "zoneIds",
  [FacilityEntityType.RESOURCE]: "resourceIds",
};
